import React from 'react';
import {
  Snackbar,
  Alert,
  AlertTitle,
  Button,
  Box,
} from '@mui/material';
import { Notification } from '../types/notification';
import { useNavigate } from 'react-router-dom';

interface NotificationSnackbarProps {
  notification: Notification | null;
  onClose: () => void;
}

const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
  notification,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleAction = () => {
    if (notification?.link) {
      navigate(notification.link);
    }
    onClose();
  };

  if (!notification) {
    return null;
  }

  return (
    <Snackbar
      open={Boolean(notification)}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={onClose}
        severity={notification.type}
        variant="filled"
        sx={{ width: '100%' }}
        action={
          notification.link && (
            <Button color="inherit" size="small" onClick={handleAction}>
              {notification.linkText || 'Ver detalhes'}
            </Button>
          )
        }
      >
        <AlertTitle>{notification.title}</AlertTitle>
        <Box component="span">{notification.message}</Box>
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbar; 